<template>
  <div class="modal">
    <div class="content">
      <h3>{{ title }}</h3>
      <slot class="message" name="message"></slot>
      <div class="button-group">
        <touch tag="button" class="cancel" type="button" @tap="cancel">取消</touch>
        <span class="separator"></span>
        <touch tag="button" class="confirm" type="button" @tap="confirm">确定</touch>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'modal',
    props: {
      title: {
        type: String,
        default: ''
      }
    },
    methods: {
      cancel () {
        this.$emit('cancel')
      },
      confirm () {
        this.$emit('confirm')
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../assets/scss/vars";

  .modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba($black, 0.8);
    .content {
      @include position-center;
      @include border-radius;
      width: 72%;
      height: 368px;
      padding: 40px;
      text-align: center;
      background-color: $white;
      box-sizing: border-box;
      h3 {
        font-size: 36px;
        color: $black;
        line-height: 50px;
      }
      p {
        margin-top: 30px;
        font-size: 28px;
        color: $black;
        line-height: 40px;
      }
      .button-group {
        display: flex;
        margin-top: 40px;
        button {
          @include reset-button;
          flex: 1;
          height: 88px;
          font-size: 36px;
          line-height: 88px;
          background-color: transparent;
          &.cancel {
            color: $green;
          }
          &.confirm {
            color: $red;
          }
        }
        .separator {
          display: inline-block;
          width: 3px;
          height: 30px;
          margin-top: 29px;
          background-color: #EAEAEA;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Modal.vue?586f7d1e